import { render } from "./EditArrivalDeclarationStatusPage.vue?vue&type=template&id=6a809ba8"
import script from "./EditArrivalDeclarationStatusPage.vue?vue&type=script&lang=js"
export * from "./EditArrivalDeclarationStatusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__